import React from 'react';
import ModalTypeEnum from 'Modals/ModalConstants';
import connectModal from 'Modals/enhancers/ConnectModal';
import BaseModal from 'Modals/BaseModal';
import ConnectedSignatureCancelSurveyModalBody from 'Modals/content/SignatureCancelSurveyBodyContent';
import ReactDOM from 'react-dom';
import store from 'store';
import * as ReactRedux from 'react-redux';

const FreeWriteSignatureCancelSurveyModalWithRedux = connectModal(BaseModal);

export default class FreeWriteSignatureCancelSurveyModalContainer extends React.Component {
  static init(id) {
    ReactDOM.render(
      <ReactRedux.Provider store={store}>
        <FreeWriteSignatureCancelSurveyModalContainer />
      </ReactRedux.Provider>,
      document.getElementById(id),
    );
  }

  render() {
    return (
      <FreeWriteSignatureCancelSurveyModalWithRedux
        modalType={ModalTypeEnum.FREE_WRITE_CANCEL_SIGNATURE_SURVEY}
        includeHeaderCloseButton
        bodyContent={
          <ConnectedSignatureCancelSurveyModalBody
            modalType={ModalTypeEnum.FREE_WRITE_CANCEL_SIGNATURE_SURVEY}
          />
        }
        footerButtons={false}
        trackFreeWrite
        ariaLabel={'Cancel Signature Survey Request Modal'}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src-react/Modals/containers/FreeWriteSignatureCancelSurveyModal/index.jsx